'use strict';
exports.default = exports;

exports.rules = {
  adm: [
    'adm',
    'sell',
    'analy',
    'sup',
  ],
  cli: [
  ],
  comp: [
    'adm',
    'edit',
    'deli',
    'att',
  ],
};

exports.stateEnrollmentsType = {
  NO_CONTRIBUTOR: 'NO_CONTRIBUTOR',
  CONTRIBUTOR: 'CONTRIBUTOR',
  IMMUNE_CONTRIBUTOR: 'IMMUNE_CONTRIBUTOR',
};

exports.apiErrorCode = {
  permissionDenied: 'permissionDenied',
  statusError: 'statusError',
  inputError: 'inputError',
  unknown: 'unknown',
  exhaustedAttempts: 'exhaustedAttempts',

  paymentError: 'paymentError',
  bagError: 'bagError',
  paymentInvalidValue: 'paymentInvalidValue',
  notFound: 'notFound',
  emailNotConfig: 'emailNotConfig',

  bagEmptyProduct: 'bagEmptyProduct',
  bagEmptyAddress: 'bagEmptyAddress',
  OK: 'OK',
  pending: 'pending',
  warningAnswered: 'warningAnswered',
  timeOver: 'timeOver',
  versionError: 'versionError',
  // Movimentação(ões) gravada(s) com sucesso, mas o lastro (extras) não foi para o RTDB. Código
  // próprio para o chamador decidir: o fechamento de repasse ABORTA (sem lastro o repasse fechado
  // não lista eventos e a reversão não desvincula), os demais fluxos só precisam avisar que o
  // item foi salvo e o detalhamento não — sem o alarme de "erro desconhecido".
  extrasError: 'extrasError',
  // Soma do PRINCIPAL quitado acima do `liquid` do item (#1150). Código próprio para a tela
  // distinguir "gravação recusada porque o item ficaria pago além do próprio valor" de um erro
  // genérico — dinheiro recebido a mais só é legítimo classificado como juros/multa na baixa.
  paymentOverflow: 'paymentOverflow',
  // Transferência com a conta de DESTINO como origem de alguma parcela (#1310): o dinheiro sairia e
  // entraria na mesma conta. Código próprio para a tela explicar a recusa e o caminho da correção.
  transferSameAccount: 'transferSameAccount',

};

// response example: {isOk:false, errorCode: orderErrorCode.unknown, msg:''}

exports.VerifyStatus = {
  approved: 'approved',
  pending: 'pending',
  waitApproved: 'waitApproved',
};

exports.JobState = {
  NOT_STARTED: 'NOT_STARTED',
  RUNNING: 'RUNNING',
  FINISH: 'FINISH',
};

/**
* Se adicionar alguma acomodação aqui é importa revisitar as configurações no convênio
**/
exports.Accommodation = {
  NURSERY: 'NURSERY',
  APARTMENT: 'APARTMENT',
  OUTPATIENT: 'OUTPATIENT',
  ONE_DAY_CLINIC: 'ONE_DAY_CLINIC',
  NONE: 'NONE',
};

exports.CustomProportionType = {
  FACTOR: 'FACTOR',
  VALUE: 'VALUE',
};

exports.AccommodationCodeOldXML = {
  NURSERY: '1',
  APARTMENT: '7',
  OUTPATIENT: '8',
};


exports.AccommodationCodeVersion4XML = {
  NONE: '01',
  NURSERY: '01',
  APARTMENT: '02',
  OUTPATIENT: '01',
  ONE_DAY_CLINIC: '05',
};

exports.viaDeAcessoCodes = {
  '1': 'U',
  '0.5': 'M',
  '0.7': 'D',
};

exports.viaDeAcessoCodes3x = {
  '1': '1',
  '0.5': '2',
  '0.7': '3',
};

exports.source = {
  AXREG: 'AXREG',
  WEB: 'WEB',
  iOS: 'iOS',
  ANDROID: 'ANDROID',
  SYNC: 'SYNC',
  SCRYPT: 'SCRYPT',
  SPREADSHEET: 'SPREADSHEET',
};

exports.dataSource = {
  KAXREG: 'KAXREG',             // Veio do AxReg
  KOCR: 'KOCR',                 // Lido com o OCR
  KSPREADSHEET: 'KSPREADSHEET', // Através da planilha
  KTYPED: 'KTYPED',             // Forma padrão, digitado no sistema
  KSPREADSHEETJUSTDOCTOR: 'KSPREADSHEETJUSTDOCTOR',     // Importado da planilha do Just Doctor
  KSPREADSHEETSIGA: 'KSPREADSHEETSIGA',  // Importado da planilha do SIGA
  KSPREADSHEETNOVAANESTESIOLOGIA: 'KSPREADSHEETNOVAANESTESIOLOGIA',  // Importado da planilha da Nova Anestesiologia - São José do Rio Preto
  KSPREADSHEETHOSPITALS: 'KSPREADSHEETHOSPITALS',  // Importado da planilha própria do hospital, uma aba por local
};

exports.typesAxReg = {
  anesthetists: 'KAnesthetist',
  surgeons: 'KSurgeon',
  healthInsurances: 'KInsurance',
  hospitals: 'KHospital',
};

exports.UserTypeOld = {
  ANESTHETIST: 'KAnesthetist',
  RESIDENT: 'KResident',
  USER: 'KUser'
};

exports.UserType = {
  KANESTHETIST: 'KANESTHETIST',
  KSURGEON: 'KSURGEON',
  KDENTIST: 'KDENTIST',
  KRESIDENT_ANESTHETIST: 'KRESIDENT_ANESTHETIST',
  KRESIDENT_SURGEON: 'KRESIDENT_SURGEON',
  KUSER: 'KUSER',
  KSCRUB_NURSE: 'KSCRUB_NURSE',
  KNURSE: 'KNURSE',
  KPHONOAUDIOLOGIST: 'KPHONOAUDIOLOGIST',
};

exports.UserBoardType = {
  KCRM: 'KCRM',
  KCRFA: 'KCRFA'
};

exports.ProcedureType = {
  KOVERRIDEPORTE: 'KOVERRIDEPORTE',
  KOVERRIDE: 'KOVERRIDE',
  KCUSTOM: 'KCUSTOM',
  KCBHPM: 'KCBHPM',
  KPACKAGE: 'KPACKAGE',
  KVALUEPERHOUR: 'KVALUEPERHOUR',
  KOVERRIDEINDICATOR: 'KOVERRIDEINDICATOR',
};

exports.ProcedureBillingType = {
  BILLABLE: 'BILLABLE', // Default
  NOT_BILLABLE: 'NOT_BILLABLE',
  ONLY_MAIN_ACTOR: 'ONLY_MAIN_ACTOR'
};

exports.BatchStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  ON_GOING: 'ON_GOING',
  ACCEPTED: 'ACCEPTED',
};

exports.EventStatus = {
  ProtocolCreated: 'ProtocolCreated',
  AwaitingCheck: 'AwaitingCheck',      // Aguardando Conferência
  Custom: 'Custom',                    // Customizado
  WaitSendGuia: 'WaitSendGuia',        // Aguardando Envio Guia/XML
  WaitPayment: 'WaitPayment',          // Aguardando Pagamento
  WaitSendRecourse: 'WaitSendRecourse',// Aguardando Envio de Recurso
  WaitRecourse: 'WaitRecourse',        // Aguardando Recurso
  Finished: 'Finished',                // Finalizado
  Received: 'Received',                // Recebido
  PartialLosed: 'PartialLosed',        // Parcialmente Perdido
  Losed: 'Losed',                      // Perdido
  PartialCuted: 'PartialCuted',        // Parcialmente Glosado
  Cuted: 'Cuted',                      // Glosado
  Released: 'Released',
  Imported: 'Imported',
  Pending: 'Pending',                  // Pendente
  CustomInfo: 'CustomInfo',            // CustomInfo
  WaitFill: 'WaitFill',                // Em Preenchimento
  Filled: 'Filled',                    // Preenchido
  InternalPending: 'InternalPending',  // Pendência interna
};

exports.EventStatusFinished = [
  exports.EventStatus.Finished,
  exports.EventStatus.Received,
  exports.EventStatus.PartialLosed,
  exports.EventStatus.Losed,
  exports.EventStatus.PartialCuted,
  exports.EventStatus.Cuted,
];

exports.EventStatusUnfinished = [
  exports.EventStatus.ProtocolCreated,
  exports.EventStatus.AwaitingCheck,
  exports.EventStatus.Custom,
  exports.EventStatus.WaitSendGuia,
  exports.EventStatus.WaitPayment,
  exports.EventStatus.WaitSendRecourse,
  exports.EventStatus.WaitRecourse,
  exports.EventStatus.Pending,
  exports.EventStatus.CustomInfo,
];

exports.AppealStatus = {
  WaitSend: 'WaitSend',
  Sent: 'Sent',
  ResponseReceived: 'ResponseReceived',
  Finished: 'Finished',
};

exports.ContractStatus = {
  Open: 'KOpen',
  WaitPayment: 'KWaitPayment',
  Closed: 'KClosed',
};

exports.ContractInstallmentStatus = {
  WaitPayment: 'KWaitPayment',
  Received: 'KReceived',
};

exports.MeasurementUnits = {
  Day: 'KDay',
  Week: 'KWeek',
  Month: 'KMonth',
  Year: 'KYear',
};

exports.PersonTypes = {
  Event: 'KEvent',
};

exports.FinancialItemTypes = {
  Income: 'KIncome',
  Outcome: 'KOutcome',
};

/*
  Quando adicionar/remover algum tipo aqui é importante verificar os arquivos que utilizam o tipo
   'TeamType' que está no arquivo deault.d.ts
 */
exports.TeamTypes = {
  KSURGEON: 'KSURGEON',
  KASSISTANT_SURGEON: 'KASSISTANT_SURGEON',
  KSCRUB_NURSE: 'KSCRUB_NURSE',
  KANESTHETIST: 'KANESTHETIST',
  KASSISTANT_ANESTHETIST: 'KASSISTANT_ANESTHETIST',
  /*
  @deprecated
   */
  KSECONDARY_ANESTHETIST: 'KSECONDARY_ANESTHETIST',

  KRESIDENT_SURGEON: 'KRESIDENT_SURGEON',
  KRESIDENT_ANESTHETIST: 'KRESIDENT_ANESTHETIST',
  KNURSE: 'KNURSE',

  KOVERRIDE_EXECUTANT: 'KOVERRIDE_EXECUTANT', // A priori será utilizado somente para substituir o executante no xml.
  KREQUESTER: 'KREQUESTER',
  KPHONOAUDIOLOGIST: 'KPHONOAUDIOLOGIST',
};

exports.TeamTypesOrder = {
  KSURGEON: 0,
  KASSISTANT_SURGEON: 1,
  KSCRUB_NURSE: 2,
  KANESTHETIST: 3,
  KRESIDENT_SURGEON: 4,
  KRESIDENT_ANESTHETIST: 5,
  KNURSE: 6,
  KOVERRIDE_EXECUTANT: 7,
  KREQUESTER: 8,
  KPHONOAUDIOLOGIST: 9,
};

exports.TeamTypesArray = [
  exports.TeamTypes.KSURGEON,
  exports.TeamTypes.KASSISTANT_SURGEON,
  exports.TeamTypes.KSCRUB_NURSE,
  exports.TeamTypes.KANESTHETIST,
  exports.TeamTypes.KASSISTANT_ANESTHETIST,
  /*
  @deprecated
   */
  exports.TeamTypes.KSECONDARY_ANESTHETIST,

  exports.TeamTypes.KRESIDENT_ANESTHETIST,
  exports.TeamTypes.KRESIDENT_SURGEON,
  exports.TeamTypes.KNURSE,
  exports.TeamTypes.KOVERRIDE_EXECUTANT,
  exports.TeamTypes.KREQUESTER,
  exports.TeamTypes.KPHONOAUDIOLOGIST,
];

exports.ObservationType = {
  Remove: 'Remove',
  RevertStatus: 'RevertStatus',
  Message: 'Message',
  Pending: 'Pending',
  InternalPending: 'InternalPending',
  Guide: 'Guide',
};


exports.EventEstatusProcessing = [
  exports.EventStatus.AwaitingCheck,
  exports.EventStatus.Custom,
  exports.EventStatus.WaitSendGuia,
  exports.EventStatus.WaitPayment,
  exports.EventStatus.WaitSendRecourse,
  exports.EventStatus.WaitRecourse,
];

/**
 *
 * @type {(string)[]}
 */
exports.EventStatusNotChecked = [
  exports.EventStatus.AwaitingCheck,
  exports.EventStatus.Custom,
  exports.EventStatus.Pending,
  exports.EventStatus.Filled,
  exports.EventStatus.InternalPending,
  exports.EventStatus.WaitFill,
];

/**
 * Status em que o evento JÁ passou pela conferência (check) — saiu do grupo
 * "não conferido" e entrou no fluxo de cobrança / recurso / finalização:
 * Aguardando Envio de Guia, Aguardando Pagamento, Aguardando Envio de Recurso,
 * Aguardando Recurso, Finalizado, Recebido, (Parcialmente) Perdido e
 * (Parcialmente) Glosado.
 *
 * Regra de negócio: o salvamento de uma edição do evento NUNCA pode retroceder
 * um status desta lista para Aguardando Conferência / Preenchido / Em
 * Preenchimento. O único caminho de volta é a ação explícita de reverter
 * status (EventActions.revertToAwaitCheck / revertStatusToChangeValues), que
 * exige a permissão AuthActions.revertStatus.
 *
 * É o complemento de EventStatusNotChecked: os status pré-conferência
 * (AwaitingCheck, Custom, Pending, Filled, InternalPending, WaitFill) e os de
 * entrada (ProtocolCreated, Released, Imported, CustomInfo) continuam podendo
 * ser levados a AwaitingCheck ao salvar.
 *
 * @type {(string)[]}
 */
exports.EventStatusAfterCheck = [
  exports.EventStatus.WaitSendGuia,
  exports.EventStatus.WaitPayment,
  exports.EventStatus.WaitSendRecourse,
  exports.EventStatus.WaitRecourse,
  ...exports.EventStatusFinished,
];

/**
 * Indica se o evento já passou pela conferência e, portanto, seu status não
 * pode ser rebaixado por um salvamento de edição.
 *
 * @param {string} eventStatus - valor de `event.status.status`.
 * @returns {boolean}
 */
exports.isEventStatusAfterCheck = function(eventStatus) {
  return exports.EventStatusAfterCheck.includes(eventStatus);
};

const EventActions = exports.EventActions = {
  edit: 1n,
  check: 2n,
  sendGuia: 4n,
  receiveAll: 8n,
  loseAll: 16n,
  recourseIdentify: 32n,
  recourseSend: 64n,
  finalize: 128n,
  cancel: 256n,
  glosaAll: 512n,
  editProcedure: 1024n,
  recourseReceived: 2048n,
  showHistory: 4096n,
  showInvoice: 8192n,
  showAdditionalData: 16384n,
  revertToAwaitCheck: 32768n,
  remove: 65536n,
  pending: 131072n,
  editValues: 262144n,
  addToBatch: 524288n,
  customStatus: 1048576n,
  customStatusAction: 2097152n,
  showValues: 4194304n,
  showCustomFields: 8388608n,
  selectTypeOfPayment: 16777216n,
  finalizeNotValued: 33554432n,
  exportContaAzul: 67108864n,
  addComment: 134217728n,
  revertStatusToChangeValues: 268435456n,
  sendToMatriz: 536870912n,
  internalPending: 1073741824n,
  resolvePending: 2147483648n,
  sendToAwaitCheckEvents: 4294967296n,
  showTransferDistribution: 8589934592n,
};

exports.ActionsIntegrationsEvents = {
  edit: 1,
  delete: 2,
  associateAnesthetist: 4,
  associateSurgeon: 8,
  associateHospital: 16,
  associateHealthInsurance: 32,
  associatePatient: 64,
  becomeVolanEvent: 128,
  import: 256,
  associateSecondaryAnesthetist: 512,
  associateResident: 1024,
  associateType: 2048,
  associateAccommodation: 4096,
  updateEvent: 8192,
  changeProportion: 16384,
  associateCompany: 32768,
  // Papéis que moram em `event.actors`, sem campo próprio no evento. Os valores
  // seguem a progressão por consistência; o enum não é usado como máscara de
  // bits em lugar nenhum.
  associateRequester: 65536,
  associateOverrideExecutant: 131072,
  associatePhonoaudiologist: 262144,
  associateAssistantSurgeon: 524288,
};

exports.TypeIntegrationsEvents = {
  IntegrationEvents: 'integrationsEvents',
  Imported: 'integrationsEventsImported',
};


exports.EventActionsNeedConfirm = EventActions.check | EventActions.sendGuia
  | EventActions.receiveAll | EventActions.loseAll | EventActions.recourseIdentify
  | EventActions.recourseSend | EventActions.recourseReceived | EventActions.finalize
  | EventActions.remove | EventActions.customStatus | EventActions.customStatusAction;

exports.EventActionsNeedConfirmMessage = EventActions.pending | EventActions.revertToAwaitCheck | EventActions.remove | EventActions.internalPending;

exports.EventActionsNeedBillingAccess = EventActions.check | EventActions.sendGuia
  | EventActions.receiveAll | EventActions.loseAll | EventActions.recourseIdentify
  | EventActions.recourseSend | EventActions.recourseReceived | EventActions.finalize
  | EventActions.revertToAwaitCheck | EventActions.remove | EventActions.editProcedure;

exports.EventAttachments = [
  {id: 'guide'},
  {id: 'record'},
  {id: 'rgo'},
  {id: 'term'},
  {id: 'apa'},
  {id: 'medicalRecord'},
  {id: 'hospitalizationForm'},
  {id: 'networkCharter'},
  {id: '3AFile'},
  {id: 'other'},
];

exports.states = [
  {id:28, code:'--'},
  {id:1, code:'AC'},
  {id:2, code:'AL'},
  {id:3, code:'AP'},
  {id:4, code:'AM'},
  {id:5, code:'BA'},
  {id:6, code:'CE'},
  {id:7, code:'DF'},
  {id:8, code:'ES'},
  {id:9, code:'GO'},
  {id:10, code:'MA'},
  {id:11, code:'MT'},
  {id:12, code:'MS'},
  {id:13, code:'MG'},
  {id:14, code:'PA'},
  {id:15, code:'PB'},
  {id:16, code:'PR'},
  {id:17, code:'PE'},
  {id:18, code:'PI'},
  {id:19, code:'RJ'},
  {id:20, code:'RN'},
  {id:21, code:'RS'},
  {id:22, code:'RO'},
  {id:23, code:'RR'},
  {id:24, code:'SC'},
  {id:25, code:'SE'},
  {id:26, code:'SP'},
  {id:27, code:'TO'},
];


exports.access = {
  user: 'user',
  admin: 'admin',
};

exports.accessList = ['user', 'admin'];

exports.Porte2PorteAnestesico = {
  '3A': 1,
  '3C': 2,
  '4C': 3,
  '6B': 4,
  '7C': 5,
  '9B': 6,
  '10C': 7,
  '12A': 8,
};

exports.Porte2PorteAnestesicoOld = {
  '3A': '1',
  '3C': '2',
  '4C': '3',
  '6B': '4',
  '7C': '5',
  '9B': '6',
  '10C': '7',
  '12A': '8',
};

exports.PorteAnestesico2Porte = {
  0: '0',
  1: '3A',
  2: '3C',
  3: '4C',
  4: '6B',
  5: '7C',
  6: '9B',
  7: '10C',
  8: '12A',
};


exports.OcrCompType = {
  text: 'text',
  date: 'date',
  number: 'number',
  label: 'label'
};

exports.OcrStatus = {
  KWaitingAnalyze: 'KWaitingAnalyze',
  KDone: 'KDone',
  KError: 'KError',
  KErrorThreshold: 'KErrorThreshold',
  KErrorNotFoundMatriz: 'KErrorNotFoundMatriz',
  KErrorEmptyCredits: 'KErrorEmptyCredits',
};



exports.FormInputType = {
  text: 'text',
  paragraph: 'paragraph',
  number: 'number',
  radio: 'radio',
  checkbox: 'checkbox',
  select: 'select',
  date: 'date',
  time: 'time',
  dateTime: 'dateTime',
  booleanNa: 'booleanNa',
};

exports.FormInputTypeReport = {
  one: 'one',
  exists: 'exists',
  multi: 'multi',
};

exports.FormLinkType = {
  none: 'none',
  eventId: 'eventId',
  eventAnesthetistName: 'eventAnesthetistName',
  eventPatientName: 'eventPatientName',
  eventPatientBirthDate: 'eventPatientBirthDate',
  eventDate: 'eventDate',
  userId: 'userId',
  userName: 'userName',
  userEmail: 'userEmail',
  companyId: 'companyId',
  companyName: 'companyName',
  eventSurgeonName: 'eventSurgeonName',
  eventHospitalName: 'eventHospitalName',
};

exports.EventType = {
  Honorario: 'Honorario',
  SPSADT: 'SPSADT',
  Consulta: 'Consulta',
};

exports.CompanyType = {
  personal: 'personal',
  company: 'company',
};

exports.defaultInGuide = {
  consultType: '1',
  accidenteIndication: '9',
  attendanceRN: 'N',
  attendimentType: '04',
  reasonToFinishAttendiment: '',
  tableCode: '22',
  tableCodeVersion2x: '16',
  grauPart: '06',
  grauPartSecondAnesthetist: '07',
  reasonForLeavingConsultationGuide: '5',
  reasonForLeavingSADTGuide: '5',
  typeDisease: 'A',
  proceduresMaxRowsPerPage: {
    SPSADT: 3,
    Consulta: 1,
    Honorario: 9
  }
};

exports.AuthActions = {
  read: 'read',
  readOwn: 'readOwn',
  list: 'list',
  listOwn: 'listOwn',
  write: 'write',
  writeOwn: 'writeOwn',
  manager: 'manager',
  managerFiliais: 'managerFiliais',
  scheduler: 'scheduler',
  revertStatus: 'revertStatus',
  rm: 'rm', // remove
  readValues: 'readValues',
  writeOwnBeforeCheck: 'writeOwnBeforeCheck',
};

exports.proportionToXml = {
  '1': '1',
  '0.7': '3',
  '0.5': '2',
};

exports.BillingActions = {
  Received: 'Received',
  ReceivedToOver: 'ReceivedToOver',
  ReceivedFromOver: 'ReceivedFromOver',
  Losed: 'Losed',
  Glosado: 'Glosado',
  Discounted: 'Discounted'
};

exports.ActionsOnFinishEvent = {
  RECEIVE: 'RECEIVE',
  LOSS: 'LOSS',
  GLOSA: 'GLOSA',
  DISCOUNT: 'DISCOUNT',
};

exports.ScheduleChangeStatus = {
  Accepted: 'KAccepted',
  Rejected: 'KRejected',
  Error: 'KError',
  Pending: 'KPending',
  Cancelled: 'KCancelled'
};

exports.ScheduleChangeType = {
  Exchange: 'KExchange',
  ReplaceSource: 'KReplaceSource',
  ReplaceDestiny: 'KReplaceDestiny',
};
exports.techniquesUsedCodes = {
  KConventional: '1',
  KVideo: '2',
  KRobotic: '3',
  KNone: '1',
};
exports.techniquesUsed = {
  KConventional: 'KConventional',
  KVideo: 'KVideo',
  KRobotic: 'KRobotic',
  KNone: 'KNone',
};

exports.TaxBase = {
  BeforeReceivedValue: 'BeforeReceivedValue', // Antes do valor base recebido, usado no caso da UNIMED
  ReceivedValue: 'ReceivedValue', // Antes de aplicar os impostos de Tomador
  Received: 'Received',           // Impostos tomador
  Repasse: 'Repasse',             // Impostos depois de descontado os impostos de tomador
  //                              // Aqui é a aplicação das deduções de IRRF
  BaseIRRF: 'BaseIRRF',           // Imposto em cima de IRRF, em geral, somente o IRRF
  Liquid: 'Liquid',
  LiquidValue: 'LiquidValue',
  Custom: 'Custom',
};

// Customização manual de um imposto DENTRO de uma movimentação (FinancialItemEntity.taxesCustom):
// o que o usuário fixou na tela e que o recálculo (calcTaxFinancialItem) deve preservar.
exports.TaxCustomMode = {
  VALUE: 'VALUE',   // o valor em R$ é fixo; a % exibida é derivada
  FACTOR: 'FACTOR', // a % (fator) é fixa; valor = base da etapa × fator
};

exports.TaxType = {
  TAX: 'TAX',
  FEE: 'FEE',
};

exports.TransferStatus = {
  OPEN: 'OPEN',
  LOCKED: 'LOCKED',
};

exports.TransferMode = {
  ALL: 'ALL',
  RECEIVED: 'RECEIVED',
  RECURSED: 'RECURSED'
};

exports.TransactionType = {
  PROCEDURE: 'PROCEDURE',
  COMPLEMENTATION: 'COMPLEMENTATION',
  ATTENDANCEFEE: 'ATTENDANCEFEE',
  EXPENSE: 'EXPENSE'
};


exports.GroupPerHourType = {
  VALUE: 'VALUE',
  PORTE: 'PORTE',
  INDICATOR: 'INDICATOR',
};

exports.PackageType = {
  VALUE: 'VALUE',
  PORTE: 'PORTE',
  INDICATOR: 'INDICATOR',
  HOUR: 'HOUR',
};

exports.ProcedureUserCustom = {
  BASE: 'BASE',
  FINAL: 'FINAL',
  TABLE: 'TABLE'
};

exports.OcrGuideStatus = {
  CREATED: 'CREATED',
  NEED_CLIENT: 'NEED_CLIENT',
  NEED_DEVELOPER: 'NEED_DEVELOPER',
  NEED_SUPPORT: 'NEED_SUPPORT',
  ON_TEST: 'ON_TEST',
  READY: 'READY'
};


exports.OcrGuideCreditType = {
  PAYMENT: 'PAYMENT',
  GIFT: 'GIFT',
  TEST: 'TEST',
  GIFT_FIRST: 'GIFT_FIRST'
};

exports.TransferType = {
  EVENTS: 'EVENTS',
  HOURS: 'HOURS'
};


exports.ContractValidity = {
  KDetermined: 'KDetermined',
  KUndetermined: 'KUndetermined'
};

exports.ContractType = {
  KHour: 'KHour',
  KEvent: 'KEvent',
};


exports.EditorContentType = {
  HTML: 'HTML',
  MD: 'MD'
};

exports.CompanyBillingType = {
  MEDICAL: 'MEDICAL',
  ANESTHETIST: 'ANESTHETIST'
};

/**
 * Sistema em que a empresa pode ser usada (`company.systemLine`, #1258). Main e med gravam no
 * mesmo Firestore em formatos diferentes; a empresa que já migrou para um não pode ser usada pelo
 * outro. Ausente vale BOTH. Os valores são os MESMOS nas duas linhas: o campo mora no mesmo doc.
 * Regra em `CompanySystemLine.js`.
 */
exports.CompanySystemLine = {
  BOTH: 'BOTH',
  MED: 'MED',
  MAIN: 'MAIN',
};

exports.CBHPMApplayTo = {
  MEDICAL: 'MEDICAL',
  ANESTHETIST: 'ANESTHETIST',
  ALL: 'ALL'
};

exports.PayerType = {
  HEALTH_INSURANCE: 'HEALTH_INSURANCE',
  HOSPITAL: 'HOSPITAL'
};

exports.ReceiverType = {
  SELF: 'SELF',
  EXTERNAL: 'EXTERNAL',
};

exports.TaxIdentifier = {
  TAX: 'TAX',
  INSS: 'INSS',
  IR: 'IR',
  IRJ: 'IRJ',
  CSLL: 'CSLL',
  PIS: 'PIS',
  COFINS: 'COFINS',
  PIS_TOMADOR: 'PIS_TOMADOR',
  COFINS_TOMADOR: 'COFINS_TOMADOR',
  CUSTOM: 'CUSTOM',
  OTHER: 'OTHER',
};




exports.AgendaDisplayMode = {
  SHIFT: 'SHIFT',
  DEMAND: 'DEMAND'
};

exports.ReportsGenerator = {
  KPDF: 'KPDF',
  KXLSX: 'KXLSX',
  getDataParamsType: {
    FcmDateMonth: 'FcmDateMonth',
    FcmDateCustom: 'FcmDateCustom',
    VAutoComplete: 'VAutoComplete',
    VSelect: 'VSelect',
    FcmListDialog: 'FcmListDialog'
  },
  configs: {
    type: {
      KNUMBER: 'KNUMBER',
      KSTRING: 'KSTRING',
      KBOOLEAN: 'KBOOLEAN',
      KMONEY: 'KMONEY',
      KSEARCH: 'KSEARCH',
      KDATE: 'KDATE',
      KDATETIME: 'KDATETIME',
      KTIME: 'KTIME',
      KHOURS: 'KHOURS',
      KMINUTES: 'KMINUTES',
      KMONTHYEAR: 'KMONTHYEAR',
      KFUNCTION: 'KFUNCTION',
    }
  }
};

exports.CompanyId = {
  PETROLINA: 'ZhFAYvSOxOkMhoHXPt7O',
};

/**
 *
 * @type {{EXTERNAL_TRANSFER: 'EXTERNAL_TRANSFER', REVENUE: 'REVENUE', EXPENSE: 'EXPENSE', INTERNAL_TRANSFER: 'INTERNAL_TRANSFER'}}
 */
exports.FinancialItemsTypes = {
  REVENUE: 'REVENUE',
  EXPENSE: 'EXPENSE',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  EXTERNAL_TRANSFER: 'EXTERNAL_TRANSFER',
};

exports.ChartOfAccountsTypeValues = {
  REVENUE: 'REVENUE',
  EXPENSE: 'EXPENSE',
  BANK_ACCCOUNT: 'BANK_ACCCOUNT',
  TAXES: 'TAXES',
};

exports.FinancialItemsPaymentStatus = {
  PAID: 'PAID',
  PARTIAL_PAID: 'PARTIAL_PAID',
  PENDING: 'PENDING',
};

exports.PaymentSlipStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
};

exports.FinancialReference = {
  FINANCIAL_ENTRY: 'FINANCIAL_ENTRY',
  FINANCIAL_EXTERNAL: 'FINANCIAL_EXTERNAL',
  TRANSFER_EVENTS: 'TRANSFER_EVENTS',
  TRANSFER_HOURS: 'TRANSFER_HOURS',
  TRANSFER_SCHEDULES: 'TRANSFER_SCHEDULES'
};

/**
 * Grupo de um financialItem de repasse quando o recebedor tem a flag
 * `financial.splitHonorario`: os eventos do tipo Honorário (EventType.Honorario)
 * geram um item separado dos demais.
 */
exports.HonorarioGroup = {
  HONORARIO: 'HONORARIO',
  OUTROS: 'OUTROS',
};

exports.FinancialPersonType = {
  /**
   * PF
   */
  FINANCIAL_PERSON_NATURAL: 'FINANCIAL_PERSON_NATURAL',
  /**
   * PJ
   */
  FINANCIAL_PERSON_LEGAL: 'FINANCIAL_PERSON_LEGAL',
  /**
   * PF até o limite, depois, PJ
   */
  FINANCIAL_PERSON_NATURAL_LIMIT: 'FINANCIAL_PERSON_NATURAL_LIMIT',
};

exports.FinancialNegotiatorOrigin = {
  COMPANY: 'COMPANY',
  USER: 'USER',
  SUPPLIER: 'SUPPLIER',
  HEALTH_INSURANCE: 'HEALTH_INSURANCE',
  HOSPITAL: 'HOSPITAL',
  BANK_ACCCOUNT: 'BANK_ACCCOUNT',
  TAX_ACCCOUNT: 'TAX_ACCCOUNT',
  PATIENT: 'PATIENT'
};

exports.FinancialPaymentFormat = {
  MONEY: 'MONEY',
  CHEQUE: 'CHEQUE',
  PIX: 'PIX',
  CREDIT: 'CREDIT',
  BANK_TRANSFER: 'BANK_TRANSFER',
  BOLETO: 'BOLETO',
  DARF: 'DARF',
  DEBIT_AUTOMATIC: 'DEBIT_AUTOMATIC',
  EXTERNAL_ACCOUNT: 'EXTERNAL_ACCOUNT',
  USING_REVENUE: 'USING_REVENUE',
  USING_EXPENSE: 'USING_EXPENSE',
};
exports.FinancialPaymentFormatList = [exports.FinancialPaymentFormat.MONEY, exports.FinancialPaymentFormat.CHEQUE,
  exports.FinancialPaymentFormat.PIX, exports.FinancialPaymentFormat.CREDIT, exports.FinancialPaymentFormat.BANK_TRANSFER,
  exports.FinancialPaymentFormat.BOLETO, exports.FinancialPaymentFormat.DARF, exports.FinancialPaymentFormat.DEBIT_AUTOMATIC,
  exports.FinancialPaymentFormat.EXTERNAL_ACCOUNT, exports.FinancialPaymentFormat.USING_EXPENSE, exports.FinancialPaymentFormat.USING_REVENUE];

/**
 * Formatos que o SISTEMA grava e o usuário NÃO escolhe (review do PR #1120):
 *
 * - `USING_EXPENSE`/`USING_REVENUE` nascem do encontro de contas e do abatimento pré-nota, e são
 *   a marca que `isLinkedPayment` (cliente e servidor) usa para dizer "esta baixa pertence a
 *   outro documento". Uma parcela avulsa que o operador marcasse com um deles ficaria travada
 *   para edição e sem botão de estorno, apontando para um documento de origem que não existe;
 * - `EXTERNAL_ACCOUNT` saiu do fluxo na fase 0 da #1111 (decisões #6/#8) — a conta externa não
 *   recebe mais lançamentos. Deixá-lo no select só permite rotular como "conta externa" um
 *   pagamento que debita uma conta real.
 *
 * Nada é removido do enum nem da `FinancialPaymentFormatList`: os dados já gravados continuam
 * sendo lidos e traduzidos normalmente. O que muda é a lista OFERECIDA nos selects.
 */
exports.FinancialPaymentFormatSystem = [exports.FinancialPaymentFormat.EXTERNAL_ACCOUNT,
  exports.FinancialPaymentFormat.USING_EXPENSE, exports.FinancialPaymentFormat.USING_REVENUE];

/** Formatos oferecidos ao usuário nos selects de pagamento (ver FinancialPaymentFormatSystem). */
exports.FinancialPaymentFormatListManual = exports.FinancialPaymentFormatList
  .filter((a) => !exports.FinancialPaymentFormatSystem.includes(a));

// Ponto da dedução de uma RECEITA no encontro de contas (issue #1111, decisões #1/#9 —
// docs/financial/FechamentoFinanceiro.md). Determina ONDE e QUANDO ela abate a despesa:
// - NOTA: abatimento pré-nota — reduz o valueBaseTransfer da despesa no CÁLCULO do repasse
//   (antes da NF; para PF reduz a base do IRRF). Só acontece com o item em aberto/repasse OPEN;
// - LIQUID: compensação pós-impostos — baixa pareada no fechamento financeiro, a qualquer momento.
exports.FinancialDeductionPoint = {
  NOTA: 'NOTA',
  LIQUID: 'LIQUID',
};
exports.FinancialDeductionPointList = [exports.FinancialDeductionPoint.NOTA, exports.FinancialDeductionPoint.LIQUID];

exports.FinancialItemExtrasItemType = {
  EVENT: 'EVENT',
  HOURS: 'HOURS',
  RECURRENT: 'RECURRENT',
  ANY: 'ANY',
};


exports.BankAccountType = {
  CREDIT: 'CREDIT',
  CHECKING_ACCOUNT: 'CHECKING_ACCOUNT', // Conta corrente
  SAVINGS_ACCOUNT: 'SAVINGS_ACCOUNT', // conta poupança
  CASHIER: 'CASHIER', // CAIXA
  APPLICATION: 'APPLICATION', // Aplicação
};

/**
 * Chaves de PAPEL das categorias padrão do plano de contas. O VALOR é a própria chave (não mais um
 * id de documento volan hardcoded, como antes do rework do plano de contas).
 *
 * Para obter o docId real, resolva sempre via `getDefaultCategoryId(company, key)`
 * (@common/financial/DefaultCategories) — ele lê `company.financialDefaultCategories[key]` e cai no
 * id volan legado (@common/financial/ChartOfAccountsPreset → FinancialDefaultCategoryLegacyIds)
 * enquanto a empresa não migrou. NUNCA use este valor diretamente como categoryId.
 */
exports.FinancialDefaultCategory = {
  TAXES: 'TAXES',
  REVENUE_HEALTHINSURANCES: 'REVENUE_HEALTHINSURANCES',
  REVENUE_HOSPITAL: 'REVENUE_HOSPITAL',
  EXPENSE_USER: 'EXPENSE_USER',
  EXPENSE_COMPANY: 'EXPENSE_COMPANY',
  REVENUE_EVENT_EXTERNAL: 'REVENUE_EVENT_EXTERNAL',
  EXTERNAL_BANK_ACCOUNT_CATEGORY: 'EXTERNAL_BANK_ACCOUNT_CATEGORY',
  REVENUE_ATTENDANCE_FEE: 'REVENUE_ATTENDANCE_FEE',
  REVENUE_PRIVATE: 'REVENUE_PRIVATE',
};

exports.FieldDisplayType = {
  NOT_VISIBLE: 'NOT_VISIBLE',
  VISIBLE: 'VISIBLE',
  EXTERNAL: 'EXTERNAL',
  MANDATORY: 'MANDATORY',
  MANDATORY_EXTERNAL: 'MANDATORY_EXTERNAL'
};

exports.MandatoryType = {
  EVENT: 'EVENT',
  XML: 'XML'
};

exports.Core = {
  MAX_INTERVAL_DAYS: 60,
  listAnesthetistsModeOptions: {
    ALL: 'ALL',
    ONLY_SCHEDULED: 'ONLY_SCHEDULED',
    NOT_SCHEDULED: 'NOT_SCHEDULED',
    VACATION: 'VACATION',
  }
};

exports.ScheduleCollections = {
  onCallSchedule: 'onCallSchedule',
  scheduleOnDutyAllocated: 'scheduleOnDutyAllocated'
};

exports.FinancialItemListMode = {
  ALL: 'ALL',
  ONLY_INVOICES: 'ONLY_INVOICES',
  ONLY_RECURRENT: 'ONLY_RECURRENT',
  GROUP: 'GROUP',
};

// Conciliação Bancária
exports.BankReconciliationOperationStatus = {
  IMPORTING: 'IMPORTING',
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

exports.BankMovementReconciliationStatus = {
  PENDING: 'PENDING',
  MATCHED: 'MATCHED',
  DISCREPANCY: 'DISCREPANCY',
  IGNORED: 'IGNORED',
  MANUAL: 'MANUAL',
};

exports.BankMovementType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
};

exports.BankMovementCategory = {
  PIX: 'PIX',
  TED: 'TED',
  DOC: 'DOC',
  BOLETO: 'BOLETO',
  CHEQUE: 'CHEQUE',
  DEBITO_AUTOMATICO: 'DEBITO_AUTOMATICO',
  TRANSFERENCIA: 'TRANSFERENCIA',
  SAQUE: 'SAQUE',
  DEPOSITO: 'DEPOSITO',
  CARTAO_DEBITO: 'CARTAO_DEBITO',
  CARTAO_CREDITO: 'CARTAO_CREDITO',
  OTHER: 'OTHER',
};

exports.ReconciliationMatchType = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
  SUGGESTED: 'SUGGESTED',
};

exports.ReconciliationSuggestionStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  SUPERSEDED: 'SUPERSEDED',
};

exports.CreatedByCompanyType = {
  KMATRIZ: 'KMATRIZ',
  KFILIAL: 'KFILIAL',
  KPERSONALPRODUCTION: 'KPERSONALPRODUCTION',
};

exports.ExternalINSSType = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

exports.MandatoryFieldsMode = {
  CREATE: 'CREATE',
  CHECK: 'CHECK',
  XML: 'XML'
};

exports.FinancialItemReconciliationStatus = {
  NOT_RECONCILED: 'NOT_RECONCILED',           // Não conciliado
  FULLY_RECONCILED: 'FULLY_RECONCILED',       // Totalmente conciliado
  PARTIALLY_RECONCILED: 'PARTIALLY_RECONCILED', // Parcialmente conciliado
};

exports.CnabType = {
  TED: 'TED',
  BOLETO: 'BOLETO',
  PIX: 'PIX',
};

exports.CnabStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};
